import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

export class SolicitudItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: SolicitudItemViewModel[];
}

export class SolicitudItemViewModel {
    public Id: number;
    public Codigo: string;
    public RefSolicitante: string;
    public FechaEnvio: Date | null;
    public HoraEnvio: string;
    public NombreTipoSolicitudComplete: string;
    public DescripcionEstadoSolicitud: string;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public RazonSocial: string;
    public NombrePuntoInspeccion: string;
    public NombreProvincia: string;
    public Nregistro: string;
    public NombreCompletoInspector: string;
    public NombreImportador: string;
    public NombrePaisOrigen: string;
    public NombreAduana: string;
    public Ubicacion: string;
    public FechaInspeccion: Date | null;
    public HoraInspeccion: string;
    public BuqueMatriculaAwb: string;
    public IsPredua = false;
    public EsPrevia = false;
    public Mrn: string;
    public CodigoTraces: string;
    public IdEstado: number;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public CodigoTipoSolicitud: string;
    public SolicitudAsignada: number;
    public FormatoSolicitud: string;
    public EsVisibleEdicion: boolean;
    public IdTipoSolicitud: number;
    public IdSubTipoSolicitud: number;
    public IdTipoClonacion: number | null;
    public FechaFinalizacion: Date | null;
    public FechaLlegada: Date | null;
    public IdEstadoChedPp: number | null;
    public DescripcionIdEstadoChedPp: string;
    public IdentidadRealizada: string;
    public FisicaRealizada: string;
    public DocumentalRealizada: string;
    public Exportador: string;
}

export class FilterSearchingSolicitudViewModel extends FilterSearchingBaseViewModel {
    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {
        super();

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.FechaDesde = this.firstDayMonth;
        this.FechaHasta = this.lastDayMonth;
    }

    public Codigo = '';
    public IdPais: number | null;
    public IdProvincia: number | null;
    public IdPuntoInspeccion: number | null;
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public ApellidosInspector = '';
    public NombreInspector = '';
    public IsPredua: number = EnumSiNoTodos.TODOS;
    public EsPrevia: number = EnumSiNoTodos.TODOS;
    public EsPapel: number = EnumSiNoTodos.TODOS;
    public EsReImportacion: number = EnumSiNoTodos.TODOS;
    public Asignada: number = EnumSiNoTodos.TODOS;
    public Mrn = '';
    public RefSolicitante = '';
    public CodigoTraces = '';
    public NombreImportador = '';
    public NRegistro = '';
    public RazonSocial = '';
    public IdTipoSolicitud: number | null;
    public IdEstadoSolicitud: number | null;
    public IdEstadoChedPp: number | null;
    public IdTipoAsignacion: number | null;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public TieneEnvioDeMuestras: number = EnumSiNoTodos.TODOS;
    public FinalizaTraslado: number = EnumSiNoTodos.TODOS;
    public TrasladoNOFinalizado: number = EnumSiNoTodos.TODOS;
    public IdUsuario = 0;
    public EsInspector: boolean;
    public EsCoordinador: boolean;
    public EsSolicitante: boolean;
    public EsGrabador: boolean;

    public EsConsultas: boolean;
    public EsConsultasySolicitante: boolean;

    public EsConsultasyLaboratorio: boolean;
    public DocumentalRealizada: number = EnumSiNoTodos.TODOS;
    public ProcedenciaUe: number = EnumSiNoTodos.TODOS;
    public Exportador = '';
}
